// File: src/App.js
// License: All Rights Reserved
// Copyright (c) 2024 Byron Korir
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaEdit,FaTrash } from 'react-icons/fa';
import UpdateAccommodationInfo from '../accommodation/UpdateAccommodationInfo';
import { AccommodationContext } from '../context/AccommodationContext';
import UpdateAccommodationRates from './UpdateAccommodationRates';
import UpdatePictures from './UpdatePictures';
import UpdateAmenities from './UpdateAmenities';
import { AuthContext } from '../context/AuthContext';
import Swal from 'sweetalert2';
import LoadingComponent from '../components/LoadingComponent';
import ImageViewer from '../utils/ImageViewer';

const AccommodationDetails = () => {
   const { id } = useParams();
   const [accommodation, setAccommodation] = useState({});
   const [loading, setLoading] = useState(true)
   const [editRates, setEditRates] = useState(false);
   const [editDetails, setEditDetails] = useState(false);
   const {onAccChange,deleteAccommodation} = useContext(AccommodationContext)
   const [editPictures, setEditPictures] = useState(false);
   const [editAmenities,setEditAmenities] = useState(false);
   const {authToken, loggedIn, currentUser} = useContext(AuthContext)
   const [amenityImages, setAmenityImages] = useState([]);
   const [visibleAmenity, setVisibleAmenity] = useState(false);
   const [pictureImages, setPictureImages] = useState([]);
   const [visiblePicture, setVisiblePicture] = useState(false);

     // ==================== IMAGES VIEWER =====================
    //  const images=[image1,2,3,4 ...]
     const [isOpen, setIsOpen] = useState(false);
     const [currentImageIndex, setCurrentImageIndex] = useState(0);
     const [scale, setScale] = useState(1);
     // isOpen, setIsOpen,currentImageIndex, setCurrentImageIndex, scale, setScale,openModal
     const openModal = (index) => {
       setCurrentImageIndex(index);
       setScale(1); // Reset scale when opening modal
       setIsOpen(true);
     };
   
     // ==================== IMAGES VIEWER =====================

   useEffect(() => {
    if (id && authToken) {
     fetch(`https://beshapp.backend.safarinetics.com/accommodations/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${authToken && authToken}`
      }
    })
       .then((res) => res.json())
       .then((response) => {
         if (response) {
          setAccommodation(response);
          setLoading(false);
          const pictureArray = response?.pictures.map((picture) => (picture?.image));
          const amenityArray = response?.amenities.map((amenity) => (amenity?.image));
          setAmenityImages(amenityArray);
          setPictureImages(pictureArray);
        }
       })
       .catch((error) => console.error(error))
      }
   }, [id,onAccChange,authToken]);

  if (loading) {
    const loadingText = 'Loading....'
    return (
      <LoadingComponent loadingText={loadingText}/>
    );
  }
  function handleDelete(id){
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      toast:true,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAccommodation(id)
      }
    });
  }
  
 
  
  return (
    <div className="accommodation py-5" style={{backgroundColor:'rgb(1,50,32,1)',minWidth:'100%'}}>
      <h2 className='mb-3 text-center' style={{fontFamily:'junge',color:'wheat'}}>{accommodation.accommodation} ({accommodation.category})</h2>
      <div className='row mx-auto justify-content-center px-4'>
      {editDetails ? (
        <UpdateAccommodationInfo accommodation={accommodation} setEditDetails={setEditDetails} />
      ) : (
        <div id='card' className='container-fluid card col-md-5 my-2' style={{ backgroundColor: 'rgb(175, 238, 238,0.8)' }}>
          <h4
            className='card-header text-white bg-success position-relative'
          
          >
            Details:
              <span onClick={() => setEditDetails(true)} className="edit-icon" style={{ position: 'absolute', top: '50%', right: '5px', transform: 'translateY(-50%)' }}>
                <FaEdit style={{fontSize:'1rem', color: 'orange' }}/>
              </span>
            
          </h4>
          <p><strong>Location:</strong> {accommodation.location}</p>
          <p><strong>Email:</strong> <a href={`mailto:${accommodation.email}`}>{accommodation.email}</a></p>
          <p><strong>Phone:</strong> <a href={`tel:${accommodation.phone}`}>{accommodation.phone}</a></p>
        </div>
      )}
        
      
      {editRates? 
      (<UpdateAccommodationRates setEditRates={setEditRates} accommodation={accommodation}/>)
    :
    ( <div className='container-fluid card col-md-5 my-2'style={{backgroundColor: 'rgb(175, 238, 238,0.8)'}}>
    <h4
        className='card-header text-white bg-success position-relative'
        
      >
        Rates:
       
          <span onClick={()=> setEditRates(true)} style={{ position: 'absolute', top: '50%', right: '5px', transform: 'translateY(-50%)' }}>
            <FaEdit style={{fontSize:'1rem', color: 'orange' }} />
          </span>
  
      </h4>
    <ul>
      <li><strong>Adult Rates:</strong> {accommodation.rates?.adult_rates.toLocaleString()} $</li>
      <li><strong>Adults Sharing Rates:</strong> {accommodation.rates?.adults_sharing_rates.toLocaleString()} $</li>
      <li><strong>Children Rates:</strong> {accommodation.rates?.children_rates.toLocaleString()} $</li>
    </ul>
    </div>)}
     
      </div>

      <div className="container-fluid row">
        {editPictures?
        (<UpdatePictures accommodation = {accommodation} setEditPictures={setEditPictures}/>)
      :
      (<div className="col-md-6">
        
        <h3 className='card-header text-center px-4 py-3' style={{ fontFamily: 'inknut antiqua', color: 'wheat', position: 'relative' }}>
      Pictures
      <span onClick={() => setEditPictures(true)} style={{ position: 'absolute', top: '50%', right: '20%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
        <FaEdit style={{ fontSize: '1.0rem', color: 'orange' }} />
      </span>
    </h3>
      <div id={`carousel-${id}`} className="carousel slide py-2 mx-auto" data-bs-ride="carousel">
        <div className="carousel-inner">
          {accommodation?.pictures.map((picture, picIndex) => (
            <div key={picIndex} className={`carousel-item ${picIndex === 0 ? 'active' : ''}`}>
              
              
            <img
              loading="lazy"
              onClick={()=> {
                setVisiblePicture(true)
                setVisibleAmenity(false)
                openModal(picIndex)}}
              src={picture?.image}
              className="d-block w-100 rounded img-fluid"
              alt={picture?.caption}
              style={{height:'25em'}}
            />
            {visiblePicture && !visibleAmenity && (
              <ImageViewer 
              images={pictureImages}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              currentImageIndex={currentImageIndex}
              setCurrentImageIndex={setCurrentImageIndex}
              scale={scale}
              setScale={setScale}
            />
              // <Viewer visible={visiblePicture} onClose={() => setVisiblePicture(false)} images={pictureImages} />
            )}
            <div className="carousel-caption d-none d-md-block">
              <p
                className="fw-bold"
                style={{
                  zIndex: '100',
                  color: 'wheat',
                  textShadow: '2px 2px 4px rgba(1, 50, 32,1)',
                  fontSize: '1rem',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  padding: '0.5rem',
                  borderRadius: '0.5rem',
                }}
              >
                {picture.caption}
              </p>
            </div>
          </div>
          ))}
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target={`#carousel-${id}`} data-bs-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target={`#carousel-${id}`} data-bs-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  )}
        {editAmenities ? 
        (<UpdateAmenities accommodation={accommodation} setEditAmenities={setEditAmenities}/>):
        (<div className="col-md-6">
        <div style={{ position: 'relative' }}>
          <h3 className='card-header text-center py-3' style={{ fontFamily: 'inknut antiqua', color: 'wheat' }}>
            Amenities
          </h3>
          <span onClick={() => setEditAmenities(true)} style={{ position: 'absolute', top: '50%', right: '10%', transform: 'translateY(-50%)', cursor: 'pointer' }}>
            <FaEdit style={{ fontSize: '1.0rem', color: 'orange' }} />
          </span>
        </div>
        <div id={`amenities-carousel-${id}`} className="carousel slide py-2 mx-auto" data-bs-ride="carousel">
          <div className="carousel-inner">
            {accommodation?.amenities.map((amenity, amenityIndex) => (
              <div key={amenityIndex} className={`carousel-item ${amenityIndex === 0 ? 'active' : ''}`}>
              
              
              <img
                loading="lazy"
                onClick={()=> {
                  setVisibleAmenity(true)
                  setVisiblePicture(false)
                  openModal(amenityIndex)}}
                src={amenity?.image}
                className="d-block w-100 rounded"
                alt={amenity?.amenity}
                style={{height:'25em'}}
              />
              {visibleAmenity && !visiblePicture &&  (
                <ImageViewer 
                images={amenityImages}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                currentImageIndex={currentImageIndex}
                setCurrentImageIndex={setCurrentImageIndex}
                scale={scale}
                setScale={setScale}
              />
                // <Viewer visible={visibleAmenity} onClose={() => setVisibleAmenity(false)} images={amenityImages} />
              )}
              <div className="carousel-caption d-none d-md-block">
                <p
                  className="fw-bold"
                  style={{
                    zIndex: '100',
                    color: 'wheat',
                    textShadow: '2px 2px 4px rgba(1, 50, 32,1)',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    padding: '0.5rem',
                    borderRadius: '0.5rem',
                  }}
                >
                  {amenity.amenity}
                </p>
              </div>
            </div>
            ))}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target={`#amenities-carousel-${id}`} data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target={`#amenities-carousel-${id}`} data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>)}
        
      </div>
      {loggedIn && currentUser && currentUser?.position === "ADMIN" && (
        <FaTrash 
        className="btn position-absolute" 
        style={{ top: '5%', right: '15px',color:'red',backgroundColor:'rgb(0,0,0,0,0)', fontSize:'3.05rem' }}
        onClick={() => handleDelete(accommodation?.id)}
        />
      )}

    </div>
  );
};

export default AccommodationDetails;
